import { get } from 'lodash';
import { type FieldPath, type FieldValues, useFormContext } from 'react-hook-form';

/** Shared adapter plumbing: the form control plus the resolved error message for `name`. */
export function useFieldController<TForm extends FieldValues>(name: FieldPath<TForm>) {
  const {
    control,
    formState: { errors },
  } = useFormContext<TForm>();
  const message = get(errors, name)?.message as string | undefined;
  return { control, message };
}
